const BASE_URL = '/api/news';

export default (entriesCount) => ({
  page: 2,
  news: [],
  meta: {
    last_page: 0,
  },
  loading: false,

  get loadingText() {
    return this.loading ? 'Načítám...' : 'Načíst další';
  },

  getNews() {
    this.loading = true;
    const url = `${BASE_URL}?page=${this.page}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        this.news = [...this.news, ...response.data];
        this.meta = response.meta;
        this.loading = false;
        this.page++;
      });
  },

  showNextPage() {
    return this.meta.last_page > this.page;
  },

  init() {
    if (entriesCount > 10) {
      this.meta.last_page = 3;
    }
  },
});
